import React from 'react';
import { useStores } from '../use.store';

const SkipButton = () => {
    const { mapStore } = useStores();

    return (
        <div className="absolute bottom-14 right-1/2 translate-x-1/2 z-50 flex-1 flex justify-center">
            <button
                type="button"
                onClick={() => {
                    mapStore.setIsWayfindingSkipped(true);
                }}
                className="flex justify-start items-center gap-[6px] pr-4 !bg-[#FF6200] text-white text-xs sm:text-sm font-bold tracking-[.12em]"
            >
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21 9V21"
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M9.01846 19.3029C9.01801 19.4689 9.06236 19.632 9.14682 19.775C9.2313 19.918 9.35276 20.0355 9.49842 20.1152C9.63874 20.1962 9.79791 20.2389 9.95992 20.2389C10.1219 20.2389 10.2811 20.1962 10.4214 20.1152L17.0578 15.7768C17.1874 15.6931 17.2939 15.5783 17.3676 15.4428C17.4414 15.3074 17.48 15.1556 17.48 15.0014C17.48 14.8471 17.4414 14.6954 17.3676 14.5599C17.2939 14.4245 17.1874 14.3097 17.0578 14.226L10.403 9.92445C10.2626 9.84343 10.1035 9.80078 9.94146 9.80078C9.77945 9.80078 9.62028 9.84343 9.47996 9.92445C9.3343 10.0042 9.21284 10.1217 9.12836 10.2646C9.0439 10.4076 8.99955 10.5707 9 10.7368L9.01846 19.3029Z"
                        fill="white"
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                SKIP
            </button>
        </div>
    );
};

export default SkipButton;
